import type { AnalyticsConfig } from 'features/teaming/teaming-base/types';
import { sendAnalyticsInfo } from 'features/analytics/helpers';

// ===== ANALYTICS FUNCTIONS =====
export const sendCallAttemptAnalytics = (
  dispatch: <T>(action: T) => T,
  config: AnalyticsConfig,
  attemptNumber: number
): void => {
  dispatch(
    sendAnalyticsInfo({
      Method: 'callTeamingRoom',
      roomUri: config.roomUri,
      message: `Teaming Remote Call Attempt ${attemptNumber}`,
      isAcceptingAgent: config.isAcceptingAgent,
      uriUsed: `${config.roomUri};transport=tcp`,
    })
  );
};

export const sendRetryAnalytics = (
  dispatch: <T>(action: T) => T,
  config: AnalyticsConfig,
  attemptNumber: number,
  maxAttempts: number,
  backoffDelay: number
): void => {
  dispatch(
    sendAnalyticsInfo({
      Method: 'callTeamingRoom',
      message: `Retrying teaming call (attempt ${attemptNumber}/${maxAttempts})`,
      roomUri: config.roomUri,
      backoffDelay,
    })
  );
};

export const sendSuccessAnalytics = (
  dispatch: <T>(action: T) => T,
  config: AnalyticsConfig,
  attemptNumber: number
): void => {
  dispatch(
    sendAnalyticsInfo({
      Method: 'callTeamingRoom',
      message: 'Teaming Remote Call Connection Successful',
      roomUri: config.roomUri,
      attemptNumber,
    })
  );
};

export const sendFailureAnalytics = (
  dispatch: <T>(action: T) => T,
  config: AnalyticsConfig,
  attemptsExhausted: number
): void => {
  dispatch(
    sendAnalyticsInfo({
      Method: 'callTeamingRoom',
      message: 'Teaming Remote Call Failed After All Retries',
      roomUri: config.roomUri,
      attemptsExhausted,
    })
  );
};
